<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <h1 class="white--text text-h1">
        {{ message }}
      </h1>
    </v-layout>
  </v-container>
</template>

<script>
import http from '@/http';

export default {
  name: 'maintenance',
  data() {
    return {
      checkFrequency: 30000,
      message: '',
    };
  },
  methods: {
    checkStatus() {
      http.get('maintenance-mode-status').then((response) => {
        if (response.data.maintenanceModeActive) {
          this.message = response.data.message;
          this.setTimeout();
        } else {
          this.message = '';
          this.$store.dispatch('auth/logout');
          this.$store.commit('version/CLEAR_VERSIONS');
          this.$router.push({
            name: 'login',
          });
        }
      });
    },
    setTimeout() {
      setTimeout(this.checkStatus, this.checkFrequency);
    },
  },
  created() {
    this.checkStatus();
  },
};
</script>
